module.exports = __webpack_public_path__ + "static/img/日出东方控制器小程序.d50929b9.png";